var map = {
	"./apple.svg": 91107,
	"./blueberry.svg": 3907,
	"./miscanthus-grass.svg": 86053,
	"./navy-arrow.svg": 39025,
	"./pumpkin.svg": 82867,
	"./quote.svg": 11191,
	"./stars.svg": 79468,
	"./sweet-potato.svg": 22029,
	"./white-arrow.svg": 70448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25321;